"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var libphonenumber_js_1 = require("libphonenumber-js");
var metadata_min_json_1 = __importDefault(require("libphonenumber-js/metadata.min.json"));
var num_easy_log_1 = require("num-easy-log");
var metadata = metadata_min_json_1.default;
var ContactsModuleHelper = (function () {
    function ContactsModuleHelper() {
    }
    ContactsModuleHelper.transform = function (numRecord, userVariables, options) {
        var e_1, _a;
        num_easy_log_1.log.debug("NUM Record before: ".concat(JSON.stringify(numRecord)));
        var transformedNumRecord = {};
        if (!options) {
            options = {
                expandTelephone: true,
                expandSms: true,
                expandHours: true,
                expandObjects: true,
            };
        }
        var keys = Object.keys(numRecord);
        try {
            for (var keys_1 = __values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
                var objectKey = keys_1_1.value;
                if (objectKey === 'contacts' && numRecord.contacts) {
                    var daysWithHours = void 0;
                    ContactsModuleHelper.addQueryToObjects(numRecord.contacts);
                    ContactsModuleHelper.readyToDial(numRecord.contacts);
                    if (options.expandHours) {
                        if (options.daysWithHours) {
                            daysWithHours = options.daysWithHours;
                        }
                        else {
                            daysWithHours = 7;
                        }
                        ContactsModuleHelper.expandHours(numRecord, daysWithHours);
                    }
                    if (userVariables && userVariables['_C']) {
                        if (options.expandTelephone) {
                            ContactsModuleHelper.expandTelephone(numRecord.contacts, 'telephone', userVariables['_C']);
                        }
                        if (options.expandSms) {
                            ContactsModuleHelper.expandTelephone(numRecord.contacts, 'sms', userVariables['_C']);
                        }
                    }
                    if (options.expandObjects) {
                        ContactsModuleHelper.expandObjects(numRecord);
                    }
                }
                else {
                    if (objectKey === '@n') {
                        transformedNumRecord['numVersion'] = numRecord[objectKey];
                        delete numRecord[objectKey];
                    }
                    else if (objectKey === '@p') {
                        transformedNumRecord['populated'] = numRecord[objectKey];
                        delete numRecord[objectKey];
                    }
                    else if (objectKey.startsWith('@')) {
                        transformedNumRecord[objectKey] = numRecord[objectKey];
                        delete numRecord[objectKey];
                    }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        transformedNumRecord['numObject'] = numRecord;
        num_easy_log_1.log.debug("NUM Record after: ".concat(JSON.stringify(transformedNumRecord)));
        return transformedNumRecord;
    };
    ContactsModuleHelper.getKeyData = function (objectType, objectKey) {
        var keyData = ['introduction', 'hours', 'query', 'action'];
        if (objectType === 'entity') {
            keyData.push('name', 'objects');
            if (objectKey === 'person' || objectKey === 'person_link') {
                keyData.push('bio');
            }
            else if (objectKey === 'employee' || objectKey === 'employee_link') {
                keyData.push('role');
            }
            else if (objectKey === 'location' ||
                objectKey === 'location_link' ||
                objectKey === 'group' ||
                objectKey === 'group_link' ||
                objectKey === 'department' ||
                objectKey === 'department_link') {
                keyData.push('description');
            }
        }
        else if (objectType === 'method' && objectKey === 'address') {
            keyData.push('description', 'lines', 'country', 'postcode');
        }
        else if (objectType === 'method' && objectKey !== 'link') {
            keyData.push('description', 'value', 'accessibility');
        }
        else {
            keyData.push('description', '@L', 'object_display_name');
        }
        return keyData;
    };
    ContactsModuleHelper.getObjects = function (obj, key, returnType) {
        if (returnType === void 0) { returnType = 'value'; }
        var objects = [];
        for (var i in obj) {
            if (!obj.hasOwnProperty(i))
                continue;
            if (i === key) {
                if (returnType === 'value') {
                    objects.push(obj[key]);
                }
                else {
                    objects.push(obj);
                }
            }
            else if (typeof obj[i] == 'object') {
                if (i === key && obj[i].constructor.name === 'Array') {
                    if (returnType === 'value') {
                        objects.push(obj[key]);
                    }
                    else {
                        objects.push(obj);
                    }
                }
                else {
                    objects = objects.concat(ContactsModuleHelper.getObjects(obj[i], key, returnType));
                }
            }
        }
        return objects;
    };
    ContactsModuleHelper.readyToDial = function (objects) {
        var e_2, _a;
        try {
            for (var objects_1 = __values(objects), objects_1_1 = objects_1.next(); !objects_1_1.done; objects_1_1 = objects_1.next()) {
                var object = objects_1_1.value;
                if (object) {
                    var objectKey = Object.keys(object)[0];
                    var objectType = ContactsModuleHelper.objectKeyToObjectType(objectKey);
                    if (objectType === 'method' && (objectKey === 'telephone' || objectKey === 'sms')) {
                        var objectValue = object[objectKey].value;
                        if (objectValue.substring(0, 1) === '0' || objectValue.indexOf(')') > -1 || objectValue.indexOf('(') > -1 || objectValue.indexOf('|') > -1) {
                            num_easy_log_1.log.error("Error: Telephone number '".concat(objectValue, "' not internationally formatted."));
                        }
                        else {
                            if (objectValue.substring(0, 1) !== '+') {
                                object[objectKey].value = '+' + objectValue;
                            }
                        }
                    }
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (objects_1_1 && !objects_1_1.done && (_a = objects_1.return)) _a.call(objects_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    ContactsModuleHelper.addQueryToObjects = function (objects) {
        var e_3, _a;
        try {
            for (var objects_2 = __values(objects), objects_2_1 = objects_2.next(); !objects_2_1.done; objects_2_1 = objects_2.next()) {
                var object = objects_2_1.value;
                if (object) {
                    var objectKey = Object.keys(object)[0];
                    var objectType = ContactsModuleHelper.objectKeyToObjectType(objectKey);
                    if (objectType === 'entity') {
                        var objectName = object[objectKey].name.trim();
                        if (!object[objectKey]['@L']) {
                            var queryToAdd = void 0;
                            if (objectKey === 'organisation' || objectKey === 'organisation_link') {
                                queryToAdd = objectName;
                            }
                            else {
                                if (objectName.substring(0, 1) === '^') {
                                    object[objectKey].name = objectName.substring(1, objectName.length);
                                }
                                if (objectKey === 'person' || objectKey === 'person_link') {
                                    queryToAdd = objectName.replace(/ /g, '.');
                                }
                                else {
                                    queryToAdd = objectName.replace(/ /g, '_');
                                }
                            }
                            object[objectKey]['@L'] = queryToAdd.toLowerCase();
                        }
                    }
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (objects_2_1 && !objects_2_1.done && (_a = objects_2.return)) _a.call(objects_2);
            }
            finally { if (e_3) throw e_3.error; }
        }
    };
    ContactsModuleHelper.expandObjects = function (numObject) {
        var e_4, _a, e_5, _b;
        if (numObject && numObject.contacts) {
            var organisation = numObject;
            if (organisation.contacts) {
                var contacts = organisation.contacts;
                try {
                    for (var contacts_1 = __values(contacts), contacts_1_1 = contacts_1.next(); !contacts_1_1.done; contacts_1_1 = contacts_1.next()) {
                        var contact = contacts_1_1.value;
                        if (contact) {
                            var objectKey = contact.method_type;
                            var objectType = ContactsModuleHelper.objectKeyToObjectType(objectKey);
                            var collectiveTerm = ContactsModuleHelper.getPlural(objectType);
                            this.addImage(contact, objectType, objectKey);
                            var dupeObject = JSON.parse(JSON.stringify(contact));
                            if (!organisation[collectiveTerm]) {
                                organisation[collectiveTerm] = {};
                            }
                            if (!organisation[collectiveTerm][objectKey]) {
                                var keysToIgnore = ContactsModuleHelper.getKeyData(objectType, objectKey);
                                keysToIgnore.push('method_type');
                                keysToIgnore.push('action');
                                organisation[collectiveTerm][objectKey] = ContactsModuleHelper.copyObjectParts(dupeObject, keysToIgnore);
                            }
                            var keyData = ContactsModuleHelper.getKeyData(objectType, objectKey);
                            if (!organisation[collectiveTerm][objectKey].list) {
                                organisation[collectiveTerm][objectKey].list = [];
                            }
                            var thisObject = {};
                            organisation[collectiveTerm][objectKey].list.push(thisObject);
                            try {
                                for (var keyData_1 = (e_5 = void 0, __values(keyData)), keyData_1_1 = keyData_1.next(); !keyData_1_1.done; keyData_1_1 = keyData_1.next()) {
                                    var ky = keyData_1_1.value;
                                    if (dupeObject[ky]) {
                                        thisObject[ky] = dupeObject[ky];
                                    }
                                }
                            }
                            catch (e_5_1) { e_5 = { error: e_5_1 }; }
                            finally {
                                try {
                                    if (keyData_1_1 && !keyData_1_1.done && (_b = keyData_1.return)) _b.call(keyData_1);
                                }
                                finally { if (e_5) throw e_5.error; }
                            }
                        }
                    }
                }
                catch (e_4_1) { e_4 = { error: e_4_1 }; }
                finally {
                    try {
                        if (contacts_1_1 && !contacts_1_1.done && (_a = contacts_1.return)) _a.call(contacts_1);
                    }
                    finally { if (e_4) throw e_4.error; }
                }
            }
        }
    };
    ContactsModuleHelper.getPlural = function (singular) {
        var plural = singular;
        if (singular === 'entity') {
            plural = 'entities';
        }
        if (singular === 'method') {
            plural = 'methods';
        }
        return plural;
    };
    ContactsModuleHelper.addImage = function (object, objectType, objectKey) {
        var metaName, imageName;
        if (objectType === 'entity') {
            if (objectKey === 'organisation' || objectKey === 'organisation_link') {
                metaName = 'logo';
                imageName = "".concat(object['@L'], ".png");
            }
            else {
                metaName = 'img';
                if (object['@L'] != null) {
                    imageName = "".concat(object['@L'], ".png");
                }
                else {
                    imageName = "holding.".concat(objectKey, ".entities.num.uk.png");
                }
            }
        }
        else if (objectType === 'method') {
            metaName = 'icon';
            imageName = "".concat(objectKey, ".media.num.uk.png");
        }
        else if (objectType === 'link') {
            return;
        }
        object[metaName] = "https://100px.logos.uk/".concat(imageName);
    };
    ContactsModuleHelper.copyObjectParts = function (objectToCopy, keysToIgnore) {
        var returnObject = {};
        for (var key in objectToCopy) {
            if (objectToCopy.hasOwnProperty(key)) {
                if (!keysToIgnore.includes(key)) {
                    returnObject[key] = objectToCopy[key];
                }
            }
        }
        return returnObject;
    };
    ContactsModuleHelper.isEmptyObject = function (objectToCheck) {
        return Object.keys(objectToCheck).length === 0 && objectToCheck.constructor === Object;
    };
    ContactsModuleHelper.expandTelephone = function (objects, key, userCountry) {
        var e_6, _a;
        try {
            for (var objects_3 = __values(objects), objects_3_1 = objects_3.next(); !objects_3_1.done; objects_3_1 = objects_3.next()) {
                var object = objects_3_1.value;
                var objectKey = object['method_type'];
                if (objectKey === key) {
                    var telephoneNumber = object.value;
                    object.value = { original: telephoneNumber };
                    var parsedNumber = (0, libphonenumber_js_1.parseNumber)(telephoneNumber);
                    if (ContactsModuleHelper.isEmptyObject(parsedNumber)) {
                        object.value.error = 'Sms telephone number not in valid international format';
                        object.value.display = telephoneNumber;
                        object.value.dial = telephoneNumber.replace(/ /gi, '');
                    }
                    else {
                        var telephoneCountry = parsedNumber['country'];
                        object.value.country = telephoneCountry;
                        var country = metadata.countries[telephoneCountry];
                        var internationalPrefix = '+' + country[0];
                        var nationalPrefix = country[5];
                        if (telephoneCountry.toLowerCase() === userCountry.toLowerCase()) {
                            if (telephoneCountry.toLowerCase() === 'us') {
                                object.value.display = telephoneNumber.replace(internationalPrefix, '').trim();
                            }
                            else if (telephoneNumber.startsWith(internationalPrefix)) {
                                object.value.display = telephoneNumber.replace(internationalPrefix, nationalPrefix).trim();
                            }
                        }
                        else {
                            if (!telephoneNumber.startsWith(internationalPrefix + ' ')) {
                                object.value.display = telephoneNumber.replace(internationalPrefix, internationalPrefix + ' ').trim();
                            }
                            else {
                                object.value.display = telephoneNumber.trim();
                            }
                        }
                        object.value.dial = telephoneNumber.replace(/ /gi, '');
                    }
                }
            }
        }
        catch (e_6_1) { e_6 = { error: e_6_1 }; }
        finally {
            try {
                if (objects_3_1 && !objects_3_1.done && (_a = objects_3.return)) _a.call(objects_3);
            }
            finally { if (e_6) throw e_6.error; }
        }
    };
    ContactsModuleHelper.expandHours = function (recordObject, daysWithHours) {
        var e_7, _a, e_8, _b;
        var hourSettings = ContactsModuleHelper.getObjects(recordObject, 'hours', 'obj');
        try {
            for (var hourSettings_1 = __values(hourSettings), hourSettings_1_1 = hourSettings_1.next(); !hourSettings_1_1.done; hourSettings_1_1 = hourSettings_1.next()) {
                var setting = hourSettings_1_1.value;
                if (setting.hours) {
                    var hoursArray = setting.hours.available;
                    if (!hoursArray) {
                        delete setting.hours['available'];
                        continue;
                    }
                    var timeZoneCity = setting.hours.time_zone_location;
                    num_easy_log_1.log.debug("Time zone city: ".concat(timeZoneCity));
                    var hoursObject = { original: hoursArray };
                    hoursObject['days'] = ContactsModuleHelper.displayDays(daysWithHours);
                    var daysObject = hoursObject['days'];
                    try {
                        for (var hoursArray_1 = (e_8 = void 0, __values(hoursArray)), hoursArray_1_1 = hoursArray_1.next(); !hoursArray_1_1.done; hoursArray_1_1 = hoursArray_1.next()) {
                            var hoursItem = hoursArray_1_1.value;
                            var hourPartsArray = hoursItem.split('@');
                            var dayDescriptor = void 0, timeDescriptor = void 0;
                            if (hourPartsArray.length === 2) {
                                dayDescriptor = hourPartsArray[0];
                                timeDescriptor = hourPartsArray[1];
                            }
                            else {
                                hoursObject['error'] = 'Invalid hours object';
                            }
                            for (var x = 0; x < daysWithHours; x++) {
                                if (ContactsModuleHelper.checkDayDescriptor(dayDescriptor, daysObject[x].date)) {
                                    daysObject[x].available = ContactsModuleHelper.setTimes(timeDescriptor);
                                }
                                else {
                                }
                            }
                        }
                    }
                    catch (e_8_1) { e_8 = { error: e_8_1 }; }
                    finally {
                        try {
                            if (hoursArray_1_1 && !hoursArray_1_1.done && (_b = hoursArray_1.return)) _b.call(hoursArray_1);
                        }
                        finally { if (e_8) throw e_8.error; }
                    }
                    if (ContactsModuleHelper.availableNow(daysObject[0].available)) {
                        hoursObject['available_now'] = true;
                    }
                    else {
                        hoursObject['available_now'] = false;
                    }
                    setting.hours = hoursObject;
                }
            }
        }
        catch (e_7_1) { e_7 = { error: e_7_1 }; }
        finally {
            try {
                if (hourSettings_1_1 && !hourSettings_1_1.done && (_a = hourSettings_1.return)) _a.call(hourSettings_1);
            }
            finally { if (e_7) throw e_7.error; }
        }
    };
    ContactsModuleHelper.displayDays = function (days) {
        var daysObj = [];
        var today = new Date();
        for (var i = 0; i < days; i++) {
            var thisDate = ContactsModuleHelper.addDays(today, i);
            var formattedDate = ContactsModuleHelper.twoDigits(thisDate.getFullYear()) +
                '-' +
                ContactsModuleHelper.twoDigits(thisDate.getMonth() + 1) +
                '-' +
                ContactsModuleHelper.twoDigits(thisDate.getDate());
            daysObj.push({ date: formattedDate });
            daysObj[i]['available'] = ['00:00:00-00:00:00'];
        }
        return daysObj;
    };
    ContactsModuleHelper.setTimes = function (hours) {
        var e_9, _a;
        var splitHours = hours.split(',');
        var returnArray = [];
        try {
            for (var splitHours_1 = __values(splitHours), splitHours_1_1 = splitHours_1.next(); !splitHours_1_1.done; splitHours_1_1 = splitHours_1.next()) {
                var hour = splitHours_1_1.value;
                var hourParts = hour.split('-');
                if (hourParts.length === 1) {
                    num_easy_log_1.log.error('Invalid hour range');
                    return ['00:00-00:00'];
                }
                else {
                    var from = ContactsModuleHelper.convertToTime(hourParts[0]);
                    var to = ContactsModuleHelper.convertToTime(hourParts[1]);
                    var openingTimes = "".concat(from, "-").concat(to);
                    returnArray.push(openingTimes);
                }
            }
        }
        catch (e_9_1) { e_9 = { error: e_9_1 }; }
        finally {
            try {
                if (splitHours_1_1 && !splitHours_1_1.done && (_a = splitHours_1.return)) _a.call(splitHours_1);
            }
            finally { if (e_9) throw e_9.error; }
        }
        return returnArray;
    };
    ContactsModuleHelper.availableNow = function (availableHours) {
        var e_10, _a;
        if (availableHours.length === 1 && availableHours[0] === '00:00:00-00:00:00') {
            return false;
        }
        else {
            try {
                for (var availableHours_1 = __values(availableHours), availableHours_1_1 = availableHours_1.next(); !availableHours_1_1.done; availableHours_1_1 = availableHours_1.next()) {
                    var available = availableHours_1_1.value;
                    var availableParts = available.split('-');
                    var now = new Date();
                    var compareTime = ContactsModuleHelper.twoDigits(now.getHours()) +
                        ':' +
                        ContactsModuleHelper.twoDigits(now.getMinutes()) +
                        ':' +
                        ContactsModuleHelper.twoDigits(now.getSeconds());
                    if (compareTime > availableParts[0] && compareTime < availableParts[1]) {
                        return true;
                    }
                }
            }
            catch (e_10_1) { e_10 = { error: e_10_1 }; }
            finally {
                try {
                    if (availableHours_1_1 && !availableHours_1_1.done && (_a = availableHours_1.return)) _a.call(availableHours_1);
                }
                finally { if (e_10) throw e_10.error; }
            }
            return false;
        }
    };
    ContactsModuleHelper.convertDate = function (theDate, type) {
        if (type === 'obj') {
            return theDate.slice(0, 4) + '-' + theDate.slice(4, 6) + '-' + theDate.slice(6, 8);
        }
        else {
            return theDate.getFullYear().toString() + ContactsModuleHelper.twoDigits(theDate.getMonth() + 1) + ContactsModuleHelper.twoDigits(theDate.getDate());
        }
    };
    ContactsModuleHelper.convertToTime = function (timeStr) {
        var timeParts, hour, minutes, seconds;
        if (timeStr.includes('.')) {
            timeParts = timeStr.split('.');
            hour = ContactsModuleHelper.twoDigits(timeParts[0]);
            if (timeParts.length > 1 && timeParts[1].length > 0) {
                minutes = ContactsModuleHelper.twoDigits(timeParts[1]);
            }
            else {
                minutes = '00';
            }
            if (timeParts.length > 2 && timeParts[2].length > 0) {
                seconds = ContactsModuleHelper.twoDigits(timeParts[2]);
            }
            else {
                seconds = '00';
            }
        }
        else {
            try {
                if (parseInt(timeStr) <= 24) {
                    hour = ContactsModuleHelper.twoDigits(timeStr);
                }
            }
            catch (err) {
                hour = '00';
            }
            minutes = '00';
            seconds = '00';
        }
        if (hour === '24') {
            return '23:59:59';
        }
        else {
            return hour + ':' + minutes + ':' + seconds;
        }
    };
    ContactsModuleHelper.checkDayDescriptor = function (dayDescriptor, checkDate) {
        var e_11, _a;
        var checkDays = [];
        if (dayDescriptor.includes(',')) {
            checkDays = dayDescriptor.split(',');
        }
        else if (dayDescriptor.includes('-')) {
            var rangeParts = dayDescriptor.split('-');
            if (rangeParts.length === 2) {
                var rangeStart = rangeParts[0];
                var rangeEnd = rangeParts[1];
                var dayNumbers = ['1', '2', '3', '4', '5', '6', '7'];
                if (dayNumbers.includes(rangeStart) && dayNumbers.includes(rangeEnd)) {
                    for (var i = 0; i < rangeEnd; i++) {
                        checkDays.push(i + 1);
                    }
                }
                else {
                    rangeStart = ContactsModuleHelper.convertDate(rangeStart, 'obj');
                    rangeEnd = ContactsModuleHelper.convertDate(rangeEnd, 'obj');
                    var start = new Date(rangeStart);
                    var end = new Date(rangeEnd);
                    var thisDate = new Date(start);
                    while (thisDate <= end) {
                        checkDays.push(ContactsModuleHelper.convertDate(thisDate, 'str'));
                        var newDate = thisDate.setDate(thisDate.getDate() + 1);
                        thisDate = new Date(newDate);
                    }
                }
            }
            else {
                num_easy_log_1.log.error('Error: invalid day range.');
                return false;
            }
        }
        else {
            checkDays = [dayDescriptor];
        }
        checkDate = new Date(checkDate);
        if (checkDays === []) {
            return false;
        }
        else {
            var jsDayNum = checkDate.getDay();
            var dayNum = void 0;
            if (jsDayNum === 0) {
                dayNum = 7;
            }
            else {
                dayNum = jsDayNum;
            }
            var checkDateDayNumber = dayNum;
            var days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
            try {
                for (var checkDays_1 = __values(checkDays), checkDays_1_1 = checkDays_1.next(); !checkDays_1_1.done; checkDays_1_1 = checkDays_1.next()) {
                    var checkDay = checkDays_1_1.value;
                    if (checkDay === 'd') {
                        return true;
                    }
                    else if (checkDay === 'wd' || checkDay === 'we') {
                        var thisDayName = days[checkDateDayNumber - 1];
                        if (checkDay === 'wd' && thisDayName !== 'Saturday' && thisDayName !== 'Sunday') {
                            return true;
                        }
                        else if (checkDay === 'we' && (thisDayName === 'Saturday' || thisDayName === 'Sunday')) {
                            return true;
                        }
                    }
                    else if (['1', '2', '3', '4', '5', '6', '7'].includes(checkDay)) {
                        if (checkDay.toString() === checkDateDayNumber.toString()) {
                            return true;
                        }
                    }
                    else if (checkDay.length === 8) {
                        if (checkDay === ContactsModuleHelper.convertDate(checkDate, 'str')) {
                            return true;
                        }
                    }
                    else {
                        return false;
                    }
                }
            }
            catch (e_11_1) { e_11 = { error: e_11_1 }; }
            finally {
                try {
                    if (checkDays_1_1 && !checkDays_1_1.done && (_a = checkDays_1.return)) _a.call(checkDays_1);
                }
                finally { if (e_11) throw e_11.error; }
            }
        }
        return false;
    };
    ContactsModuleHelper.twoDigits = function (number) {
        if (number.toString().length === 1) {
            return '0' + number.toString();
        }
        else {
            return number.toString();
        }
    };
    ContactsModuleHelper.addDays = function (theDate, days) {
        var date = new Date(theDate);
        date.setDate(date.getDate() + days);
        return date;
    };
    ContactsModuleHelper.objectKeyToObjectType = function (objectKey) {
        if (objectKey === 'organisation' ||
            objectKey === 'person' ||
            objectKey === 'employee' ||
            objectKey === 'group' ||
            objectKey === 'department' ||
            objectKey === 'location') {
            return 'entity';
        }
        return 'method';
    };
    return ContactsModuleHelper;
}());
exports.default = ContactsModuleHelper;
//# sourceMappingURL=Contacts.js.map